import { SxProps } from "@mui/material";

export const sxTextButtonInfoPlan: SxProps = {
  textAlign: 'start',
  fontSize: 16,
  fontFamily: 'UnimedSans-bold',
  textTransform: "none",
  marginLeft: '16px',
  color: '#383838',
  marginRight: '20px'
}

export const sxButtonInfoPlan: SxProps = {
  display: 'flex',
  justifyContent: 'start',
  height: '64px',
}


export const sxTypographyAdvice: SxProps = {
  color: '#4C4C4C',
  fontFamily: 'Unimed-Sans',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '400',
  lineHeight: '150%',
}

export const sxTypographyAdviceTitle: SxProps = {
  color: '#383838',
  fontFamily: 'Unimed-Sans',
  fontSize: '16px',
  fontStyle: 'normal',
  fontWeight: '700',
  lineHeight: '150%',
}

export const sxButtonText: SxProps = {
  textDecoration: 'underline',
  textTransform: 'none',
  fontFamily: 'Unimed-Sans',
  fontWeight: 600,
  padding: 0,
  '&:hover': {
    color: '#164029',
  },
  color: '#383838'
}

export const sxButtonConsultar: SxProps = {
  borderRadius: '80px',
  height: '44px',
  padding: '24px 32px',
  '@media (max-width: 899px)': {
    width: 'stretch'
  }
}

export const sxButtonTextPrint: SxProps = {
  textDecoration: 'underline',
  textTransform: 'none',
  fontFamily: 'Unimed-Sans',
  fontWeight: 600,
  padding: 0,
  color: '#00995D',
  '&:hover': {
    color: '#00834F',
  },
}

export const sxTabs: SxProps = {
  width: '100%',

  "& .MuiTabs-indicator": {
    height: "4px",
    borderBottom: '4px solid #00995D'
  },
}

export const sxTabsAccessibility: SxProps = {
  ...sxTabs,
  '& .MuiTabs-indicator': {
    height: '4px',
    background: '#FFFF00'
  },
}

export const sxTab: SxProps = {
  fontFamily: "UnimedSans-Bold",
  fontSize: "16px",
  fontWeight: 700,
  lineHeight: "30px",
  letterSpacing: "0em",
  textAlign: "center",
  textTransform: "none",
  color: "#383838",
  width: '33%',
  maxWidth: "unset !important",
  borderBottom: "4px solid #BDBDBD",
  '@media (max-width: 375px)': {
    fontSize: '11px'
  }
}

export const sxValidationMessage: SxProps = {
  fontFamily: 'Unimed-Sans',
  color: '#D84141',
  fontSize: 12
}
